var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ImageService } from '../../../../services/image.service';
var BlockNavigatorComponent = /** @class */ (function (_super) {
    __extends(BlockNavigatorComponent, _super);
    function BlockNavigatorComponent(router, imageService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.imageService = imageService;
        _this.activatedRoute = activatedRoute;
        _this.isNeedScroll = true;
        _this.stepPx = 40;
        _this.onCityClick = new EventEmitter();
        return _this;
    }
    BlockNavigatorComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.getIsNeedScroll();
    };
    BlockNavigatorComponent.prototype.cityClick = function (city) {
        this.selected = city;
        this.onCityClick.emit(city);
        this.getIsNeedScroll();
    };
    BlockNavigatorComponent.prototype.setSelectedCity = function (value) {
        this.selected = value;
    };
    BlockNavigatorComponent.prototype.setSelectedCityById = function (id) {
        if (this.items && this.items.length) {
            var city = this.items.first(function (x) { return x.id === id; });
            if (city) {
                this.selected = city;
            }
        }
    };
    BlockNavigatorComponent.prototype.scrollToCity = function (id) {
        if (this.items && this.items.length) {
            var index = this.items.getElementIndex(function (x) { return x.id === id; });
            if (index >= 0) {
                this.wrap.nativeElement.scrollLeft = 186 * index;
            }
        }
    };
    BlockNavigatorComponent.prototype.goLeft = function () {
        var _this = this;
        var width = this.wrap.nativeElement.clientWidth;
        var x = 0;
        var interval = setInterval(function () {
            _this.wrap.nativeElement.scrollBy(_this.stepPx * -1, 0);
            x = x + _this.stepPx;
            if (x >= width - 170) {
                clearInterval(interval);
            }
        }, 5);
    };
    BlockNavigatorComponent.prototype.goRight = function () {
        var _this = this;
        var width = this.wrap.nativeElement.clientWidth;
        var x = 0;
        var interval = setInterval(function () {
            _this.wrap.nativeElement.scrollBy(_this.stepPx, 0);
            x = x + _this.stepPx;
            if (x >= width - 170) {
                clearInterval(interval);
            }
        }, 5);
    };
    BlockNavigatorComponent.prototype.scrollToStart = function () {
        if (this.wrap) {
            this.wrap.nativeElement.scroll(0, 0);
        }
    };
    BlockNavigatorComponent.prototype.getIsNeedScroll = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.wrap) {
                var scrollWidth = _this.wrap.nativeElement.scrollWidth;
                var clientWidth = _this.wrap.nativeElement.clientWidth;
                console.log("scrollWidth: " + scrollWidth + ", clientWidth: " + clientWidth);
                _this.isNeedScroll = scrollWidth > clientWidth;
            }
        });
    };
    return BlockNavigatorComponent;
}(BaseComponent));
export { BlockNavigatorComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/block.navigator/block.navigator.component.ts.pre-build-optimizer.js